import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { MeetingRoutingModule } from '@business/meeting/meeting-routing.module';
import { MeetingPageComponent } from './components/meeting-page/meeting-page.component';
import { ResetPinOrTokenComponent } from './components/reset-pin-or-token/reset-pin-or-token.component';
import { UpdateMeetingMembersComponent } from './components/update-meeting-members/update-meeting-members.component';
import { UpdateMeetingComponent } from './components/update-meeting/update-meeting.component';

@NgModule({
  declarations: [
    MeetingPageComponent,
    UpdateMeetingComponent,
    UpdateMeetingMembersComponent,
    ResetPinOrTokenComponent,
  ],
  imports: [SharedModule, MeetingRoutingModule],
})
export class MeetingModule {}
